import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getLiquidacionMensual = (administracionId, periodo) =>
  axios.get(`${HOST_API}api/liquidacionMensual/GetLiquidacion`, {
    params: { administracionId, periodo },
  });

export const saveMontoPorUF = (payload) =>
  axios.post(`${HOST_API}api/liquidacionMensual/SaveMontoPorUF`, payload);
